import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { slide as Menu } from 'react-burger-menu';
import { Nav } from "react-bootstrap";


class Sidebar extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        console.log(this.props.amount)
        return (
            <ul className="right">

                <li><Link style={{ color: "black" }} to="/cart">$ {this.props.amount ? this.props.amount : this.props.total.toFixed(2)}{ } </Link></li>
                <li><Link style={{ color: "black" }} to="/cart"><i className="material-icons">shopping_cart</i></Link></li>
            </ul>



        )
    }
}

const mapStateToProps = (state) => {
    return {
        addedItems: state.addedItems,
        total: state.total,
        topping: state.topping
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addShipping: () => { dispatch({ type: 'ADD_SHIPPING' }) },
        substractShipping: () => { dispatch({ type: 'SUB_SHIPPING' }) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)

